import { FieldType } from 'modules/domains';

export const isDateFieldType = (type?: FieldType): type is FieldType.DATE =>
  type === FieldType.DATE;
